/**
 * @generated SignedSource<<e36b3e8615196f4cafc31dbc22864b18>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type JobApplicationStatus = "deleted" | "freelancer_not_interested" | "hired" | "interview" | "job_application_draft" | "job_application_invited" | "job_application_sent" | "job_viewed" | "offer" | "potential" | "rejected" | "screening_completed" | "screening_rejected" | "screening_requested" | "screening_started";
import { FragmentRefs } from "relay-runtime";
export type JobsListingItem_JobApplication$data = {
  readonly id: string;
  readonly status: JobApplicationStatus;
  readonly " $fragmentSpreads": FragmentRefs<"ApplicationStatusTextTag_JobApplication" | "ApplicationStepsButton_JobApplication" | "jobApplication_useIsUnsentJobApplication">;
  readonly " $fragmentType": "JobsListingItem_JobApplication";
};
export type JobsListingItem_JobApplication$key = {
  readonly " $data"?: JobsListingItem_JobApplication$data;
  readonly " $fragmentSpreads": FragmentRefs<"JobsListingItem_JobApplication">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "JobsListingItem_JobApplication",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ApplicationStepsButton_JobApplication"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ApplicationStatusTextTag_JobApplication"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "jobApplication_useIsUnsentJobApplication"
    }
  ],
  "type": "JobApplication",
  "abstractKey": null
};

(node as any).hash = "1505c4b4077ec9fdd46cc3c1f1ba1d8c";

export default node;
